"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Avatar;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _pathData = _interopRequireDefault(require("./pathData"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var KEY_CODES = {
  enter: 13,
  space: 32
};

var StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Avatar__StyledSvg",
  componentId: "sc-110a3h-0"
})(function (_ref) {
  var role = _ref.role,
      theme = _ref.theme,
      whiteBackground = _ref.whiteBackground;
  return (0, _styledComponents.css)(["outline:none;width:100%;height:100%;background-color:", ";", " & g.cog-intersect path{fill-rule:evenodd;}& g.bpcl-avatar-image{clip-path:url(#bpcl-avatar-image);}"], whiteBackground ? theme.color.paper : 'transparent', role === 'button' && (0, _styledComponents.css)(["&:hover{cursor:pointer;& ", ",& ", "{fill:", ";}}&:focus{& ", ",& ", "{fill:", ";}}"], PrismOutline, CogOutline, theme.color.hover, PrismOutline, CogOutline, theme.color.focus));
});

var PrismOutline = _styledComponents["default"].path.withConfig({
  displayName: "Avatar__PrismOutline",
  componentId: "sc-110a3h-1"
})(["fill:white;transition:all 0.2s ease;"]);

var PrismBorder = _styledComponents["default"].path.withConfig({
  displayName: "Avatar__PrismBorder",
  componentId: "sc-110a3h-2"
})(function (props) {
  return (0, _styledComponents.css)(["fill:", ";fill-rule:", ";"], function (props) {
    return props.theme.color.action;
  }, props.hasCogIcon ? 'evenodd' : 'nonzero');
});

var CogOutline = _styledComponents["default"].path.withConfig({
  displayName: "Avatar__CogOutline",
  componentId: "sc-110a3h-3"
})(function (_ref2) {
  var theme = _ref2.theme,
      onClick = _ref2.onClick;
  return (0, _styledComponents.css)(["fill:", ";stroke:", ";transition:0.2s ease stroke,0.2s ease fill;", ""], theme.color.paper, theme.color.paper, onClick && (0, _styledComponents.css)(["", ":hover &{fill:", ";stroke:", ";}", ":focus &{fill:", ";stroke:", ";}"], StyledSvg, theme.color.hover, theme.color.hover, StyledSvg, theme.color.focus, theme.color.focus));
});

var CogFill = _styledComponents["default"].path.withConfig({
  displayName: "Avatar__CogFill",
  componentId: "sc-110a3h-4"
})(["fill:", ";"], function (props) {
  return props.theme.color.action;
});

var Image = _styledComponents["default"].image.withConfig({
  displayName: "Avatar__Image",
  componentId: "sc-110a3h-5"
})(["width:100%;height:100%;transform-origin:50% 60%;transform:scale(0.85);"]); // TODO: Ask UX for this SVG in context of the avatar svg to keep paths relative.


var StyledHappyPrism = _styledComponents["default"].g.withConfig({
  displayName: "Avatar__StyledHappyPrism",
  componentId: "sc-110a3h-6"
})(["transform-origin:1.45rem 1.5rem;transform:scale(0.3);"]);

var _ref3 = /*#__PURE__*/_react["default"].createElement(StyledHappyPrism, null, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M3,12 a3 3 0 1 1 0 6 3 3 0 0 1 0-6z m46,0 a3 3 0 1 1 0 6 3 3 0 0 1 0-6z",
  fill: "#D4D4D4"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M14,28 c2.34 15.22 21.59 15.24 24.09-.01a2 2 0 0 0-3.95-.65c-1.77 10.77-14.55 10.76-16.19.05a2 2 0 0 0-3.95.61z",
  fill: "#434A4F"
}), /*#__PURE__*/_react["default"].createElement("rect", {
  fill: "#434A4F",
  x: "14",
  width: "4",
  height: "12",
  rx: "2"
}), /*#__PURE__*/_react["default"].createElement("rect", {
  fill: "#434A4F",
  x: "34",
  width: "4",
  height: "12",
  rx: "2"
}));

var HappyPrism = function HappyPrism() {
  return _ref3;
};
/**
 * #### Blue Prism styled `Avatar` component

The avatar component is generally used in the side menu to represent the user profile. It has no default size and will resize/fit within its parent container. By default the component is presented as an image regardless if the cog is displayed or not. However if the `onClick` prop is passed, the component will then become interactive.
 */


var _ref5 = /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
  id: "bpcl-avatar-image"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M24,9 L6,29.5 L24,40.5 L42,29.5 L24,9 Z"
})), /*#__PURE__*/_react["default"].createElement("linearGradient", {
  id: "shadow-gradient",
  x1: "0%",
  y1: "0%",
  x2: "0%",
  y2: "100%"
}, /*#__PURE__*/_react["default"].createElement("stop", {
  offset: "0%",
  stopColor: "rgba(0, 0, 0, 0.05)"
}), /*#__PURE__*/_react["default"].createElement("stop", {
  offset: "100%",
  stopColor: "rgba(0, 0, 0, 0.15)"
})));

var _ref6 = /*#__PURE__*/_react["default"].createElement(HappyPrism, {
  outline: _pathData["default"]
});

var _ref7 = /*#__PURE__*/_react["default"].createElement("polygon", {
  fill: "url(#shadow-gradient)",
  points: "24,7 44.5,30 24,42"
});

function Avatar(_ref4) {
  var _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className,
      _ref4$displayCogIcon = _ref4.displayCogIcon,
      displayCogIcon = _ref4$displayCogIcon === void 0 ? false : _ref4$displayCogIcon,
      image = _ref4.image,
      _ref4$title = _ref4.title,
      title = _ref4$title === void 0 ? '' : _ref4$title,
      _ref4$onClick = _ref4.onClick,
      onClick = _ref4$onClick === void 0 ? null : _ref4$onClick,
      _ref4$whiteBackground = _ref4.whiteBackground,
      whiteBackground = _ref4$whiteBackground === void 0 ? false : _ref4$whiteBackground;

  function handleKeyDown(event) {
    if (!onClick) return;
    if ([KEY_CODES.space, KEY_CODES.enter].includes(event.keyCode)) onClick(event);
  }

  return /*#__PURE__*/_react["default"].createElement(StyledSvg, {
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    onClick: onClick,
    tabIndex: onClick ? 0 : -1,
    role: onClick ? 'button' : 'img',
    className: className,
    "aria-labelledby": "bpcl-avatar-button-title",
    onKeyDown: handleKeyDown,
    whiteBackground: whiteBackground
  }, _ref5, title && /*#__PURE__*/_react["default"].createElement("title", {
    id: "bpcl-avatar-button-title"
  }, title), /*#__PURE__*/_react["default"].createElement("g", {
    className: "bpcl-avatar-image"
  }, image ? /*#__PURE__*/_react["default"].createElement(Image, {
    width: "100%",
    height: "100%",
    href: image,
    preserveAspectRatio: "xMidYMid slice"
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
    d: _pathData["default"].prismBackground,
    fill: "#fff"
  }), _ref6)), _ref7, /*#__PURE__*/_react["default"].createElement(PrismOutline, {
    d: _pathData["default"].prismOutline
  }), /*#__PURE__*/_react["default"].createElement(PrismBorder, {
    d: _pathData["default"].prism,
    hasCogIcon: displayCogIcon,
    className: "bpcl-avatar-prism-border"
  }), displayCogIcon && /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(4, 6)"
  }, /*#__PURE__*/_react["default"].createElement(CogOutline, {
    d: _pathData["default"].cogOutline,
    onClick: onClick
  }), /*#__PURE__*/_react["default"].createElement(CogFill, {
    d: _pathData["default"].cog
  })));
}